module.exports = __webpack_public_path__ + "static/media/green-checkmark.229afae5.jpg";